import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';
import { OrderSort, OrderSortColumn, OrderSortDirection } from './OrderSorting';
import styles from './SortableTableHeader.module.scss';

interface IProps {
  label: string;
  column: OrderSortColumn;
  sortBy: OrderSort;
  // eslint-disable-next-line no-unused-vars
  onSortChange: (sortBy: OrderSort) => void;
  align?: 'left' | 'center';
}

export default function SortableTableHeader({ label, column, sortBy, onSortChange, align = 'left' }: IProps) {
  const isActive = sortBy.column === column;
  const activeDirection = isActive ? sortBy.direction : undefined;
  const nextDirection: OrderSortDirection = isActive && sortBy.direction === 'asc' ? 'desc' : 'asc';
  const DirectionIcon = activeDirection === 'desc' ? ArrowDownIcon : ArrowUpIcon;
  const activeDirectionLabel = activeDirection === 'desc' ? 'descending' : 'ascending';
  const nextDirectionLabel = nextDirection === 'desc' ? 'descending' : 'ascending';
  const sortDescription = isActive ? `${label}, sorted ${activeDirectionLabel}. Sort ${nextDirectionLabel}` : `Sort by ${label} ascending`;
  const alignmentClass = align === 'center' ? styles.centered : '';
  const visibilityClass = isActive ? styles.active : styles.inactive;
  let ariaSort: 'ascending' | 'descending' | undefined;

  if (activeDirection === 'asc') ariaSort = 'ascending';
  if (activeDirection === 'desc') ariaSort = 'descending';

  const handleSort = () => {
    onSortChange({ column, direction: nextDirection });
  };

  return (
    <th className={styles.sortableHeader} aria-sort={ariaSort}>
      <button type="button" className={`${styles.sortButton} ${alignmentClass}`} onClick={handleSort} aria-label={sortDescription}>
        <span>{label}</span>
        <DirectionIcon className={`${styles.sortIcon} ${visibilityClass}`} aria-hidden="true" />
      </button>
    </th>
  );
}
